export default ({ productDetails, router }) => {
  const isNewSignup = router.location.query.newSignUp === '1';
  return productDetails.isBreach && isNewSignup;
};
